import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import {ViewTitle, Title} from 'admin-on-rest';
import { crudCreate as crudCreateAction } from '../../admin-on-rest/src/actions/dataActions';
import DefaultActions from './CreateActions';
import translate from '../../admin-on-rest/src/i18n/translate';
import withPermissionsFilteredChildren from '../../admin-on-rest/src/auth/withPermissionsFilteredChildren';
import { dateToWorkingHours } from '../../helpers/dateToWorkingHours';

class Create extends Component {
    getBasePath() {
        const { location } = this.props;
        return location.pathname
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    defaultRedirectRoute() {
        const { hasShow, hasEdit } = this.props;
        if (hasEdit) return 'edit';
        if (hasShow) return 'show';
        return 'list';
    }

    save = (record, redirect) => {
        const working_hours = JSON.parse(JSON.stringify(record.working_hours));
        
        dateToWorkingHours.checkTime(working_hours.regular, 'start');
        dateToWorkingHours.checkTime(working_hours.regular, 'end');
        
        dateToWorkingHours.checkTime(working_hours.saturday, 'start');
        dateToWorkingHours.checkTime(working_hours.saturday, 'end');
        
        dateToWorkingHours.checkTime(working_hours.sunday, 'start');
        dateToWorkingHours.checkTime(working_hours.sunday, 'end');
        
        const promo_ids = record.promo_ids ? JSON.parse(JSON.stringify(record.promo_ids)) : [];

        const new_record = JSON.parse(JSON.stringify(record));
        new_record.working_hours = working_hours;
        new_record.promo_ids = promo_ids;

        this.props.crudCreate(
            this.props.resource,
            new_record,
            this.getBasePath(),
            redirect
        );
    };

    render() {
        const {
            actions = <DefaultActions />,
            children,
            isLoading,
            resource,
            title,
            translate,
            hasList,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePath();

        const resourceName = translate(`resources.${resource}.name`, {
            smart_count: 1,
            _: inflection.humanize(inflection.singularize(resource)),
        });
        const defaultTitle = translate('aor.page.create', {
            name: `${resourceName}`,
        });
        const titleElement = (
            <Title title={title} defaultTitle={defaultTitle} />
        );

        return (
            <div className="create-page">
                <Card style={{ opacity: isLoading ? 0.8 : 1 }}>
                    {actions &&
                        React.cloneElement(actions, {
                            basePath,
                            resource,
                            hasList,
                        })}
                    <ViewTitle title={titleElement} />
                    {React.cloneElement(children, {
                        save: this.save,
                        resource,
                        basePath,
                        record: {},
                        translate,
                        redirect:
                            typeof children.props.redirect === 'undefined'
                                ? this.defaultRedirectRoute()
                                : children.props.redirect,
                    })}
                </Card>
            </div>
        );
    }
}

Create.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudCreate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func.isRequired,
    hasList: PropTypes.bool,
};

Create.defaultProps = {
    data: {},
};

function mapStateToProps(state) {
    return {
        isLoading: state.admin.loading > 0,
    };
}

const enhance = compose(
    connect(mapStateToProps, { crudCreate: crudCreateAction }),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(Create);



// WEBPACK FOOTER //
// ./src/components/CRM/Create.js